import { useMemo, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BreadcrumbsContainer,
  Breadcrumbs,
  useSnackbar,
  useTranslations,
  usePubSub,
} from '@uniqkey-frontend/shared-app';
import PageRouteEnum from '../../../../enums/PageRouteEnum';
import PubSubEventEnum from '../../../../enums/PubSubEventEnum';
import { useGetVaultPasswordById } from '../../../../hooks/reactQuery';

interface IOrganizationLoginPageBreadcrumbsProps {
  vaultId: string;
}
const OrganizationLoginPageBreadcrumbs = (props: IOrganizationLoginPageBreadcrumbsProps) => {
  const { vaultId } = props;
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { showError } = useSnackbar();

  const { data: vault, isLoading, refetch } = useGetVaultPasswordById(
    { vaultId },
    {
      onError: () => {
        showError({ text: t('common.somethingWentWrong') });
        navigate(PageRouteEnum.AllSecuredData);
      },
    },
  );

  const handleRefetch = useCallback(() => refetch(), [refetch]);
  usePubSub(PubSubEventEnum.DATA_SYNCHRONIZATION_VAULT, handleRefetch);

  const breadcrumbsNodes = useMemo(() => {
    if (isLoading || !vault) {
      return [];
    }
    return [
      {
        title: t('navigation.allLogins'),
        onClick: () => navigate(PageRouteEnum.AllSecuredData),
      },
      { title: t('navigation.logins'), onClick: () => navigate(PageRouteEnum.AllSecuredData) },
      { title: vault.name },
    ];
  }, [isLoading, vault, navigate, t]);

  return (
    <BreadcrumbsContainer>
      <Breadcrumbs
        nodes={breadcrumbsNodes}
        isLoading={isLoading}
      />
    </BreadcrumbsContainer>
  );
};

export default memo(OrganizationLoginPageBreadcrumbs);
